export default __webpack_public_path__ + "static/media/skapaforkortning4.eb079034.png";